import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
    root: {},
    personCard: {
        float: 'right',
        // margin: '1vh',
        fontFamily: "Rubik",
        // width: '11vw',
        textAlign: 'center',
    },
    highlight: {
        background: 'linear-gradient(180deg, rgba(120, 174, 255, 0.4) 0%, rgba(240, 249, 255, 0.4) 133.12%)',
        float: 'right',
        // margin: '1vh',
        fontFamily: "Rubik",
        // width: '11vw',
        textAlign: 'center',
    },
    personDialog: {
        width: '450px',
        padding: "10px 0",
    },
    editClass: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    female: {
        border: '2px solid #ffccff',
    },
    male: {
        border: '2px solid #b3e6ff'
    },
    nameButtonRed: {
        color: 'red',
        fontStyle: 'italic',
        fontWeight: 'bold',
        border: '2px solid red'
    },
    nameButtonBlue: {
        color: 'blue',
        fontStyle: 'italic',
        fontWeight: 'bold',
        border: '2px solid blue'
    },
    icon: {
        borderRadius: 3,
        width: 13,
        height: 13,
        boxShadow: 'inset 0 0 0 1px red, inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#00cc7a',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 13,
            height: 13,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#00cc7a',
        },
    },
    checkboxLabel: {
        fontSize: '11px',
    }
}));
